module.exports = __webpack_public_path__ + "media/preview/cert-preview-bb756ea1.png";